import { css } from 'styled-components';
import styled from 'styled-components';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import blockedPattern from '@bechtel/client-assets/dist/images/pattern-red.svg';
import { MilestoneStatus } from './types';
import { MilestoneStatusCode } from '@bechtel/types';

interface PatternStyledProps {
  status: string;
}

function getBlockedPattern() {
  return css`
    border: 1px solid ${({ theme }) => theme.colors.red[500]};
    background-color: ${({ theme }) => theme.colors.red[300]};
    background-image: url(${blockedPattern});
    background-repeat: repeat;
    background-size: ${({ theme }) => theme.fontSizes[250]};
    background-position: 0 ${({ theme }) => theme.spacings[200]};
  `;
}

function getPatternColor({ status }: PatternStyledProps) {
  switch (status) {
    case MilestoneStatus.PLANNED:
      return css`
        background-color: ${({ theme }) => theme.colors.blue[500]};
      `;
    case MilestoneStatus.APPROVED:
      return css`
        background-color: ${({ theme }) => theme.colors.green[500]};
      `;
    case MilestoneStatus.CLAIMED:
      return css`
        background-color: ${({ theme }) => theme.colors.orange[500]};
      `;
    case MilestoneStatus.REJECTED:
      return css`
        background-color: ${({ theme }) => theme.colors.purple[500]};
      `;
    case MilestoneStatusCode.REQUESTED:
      return css`
          background-color: ${({ theme }) => theme.colors.yellow[500]};
        `;
    case MilestoneStatus.BLOCKED:
      return getBlockedPattern();
    default:
      return css`
        background-color: ${({ theme }) => theme.colors.blue[500]};
      `;
  }
}

export const PatternStyled = styled.div<PatternStyledProps>`
  ${getPatternColor};

  ${({ theme }) => css`
    border-radius: ${theme.radii[100]};
    height: ${theme.fontSizes[500]};
    margin-right: ${theme.spacings[400]};
    width: ${theme.fontSizes[500]};
  `};
`;
export const WeldPatternStyled = styled.div<PatternStyledProps>`
  ${getPatternColor};

  ${({ theme }) => css`
    border-radius: ${theme.radii[300]};
    height: ${theme.fontSizes[100]};
    margin-right: ${theme.spacings[400]};
    width: ${theme.fontSizes[600]};
  `};
`;
